module.exports = __webpack_public_path__ + "static/media/adriana_da_silva_jacinto.864cbf13.jpg";